import moment from 'moment-timezone'
import { isValid as isValidCpf } from '@fnando/cpf'
import { isValid as isValidCpnj } from '@fnando/cnpj'

// Valida CNPJ alfanumérico conforme Instrução Normativa RFB 2.229/2024.
// Aceita string sem formatação (14 chars, A-Z e 0-9, DV nos dois últimos).
const isValidCnpjAlfanumerico = cnpj => {
  if (!cnpj || cnpj.length !== 14) return false
  if (!/^[0-9A-Z]{12}[0-9]{2}$/.test(cnpj)) return false

  const calcDigit = str => {
    let sum = 0
    let weight = 2
    for (let i = str.length - 1; i >= 0; i--) {
      sum += (str.charCodeAt(i) - 48) * weight
      weight = weight === 9 ? 2 : weight + 1
    }
    const remainder = sum % 11
    return remainder < 2 ? 0 : 11 - remainder
  }

  return (
    calcDigit(cnpj.slice(0, 12)) === Number(cnpj[12])
    && calcDigit(cnpj.slice(0, 13)) === Number(cnpj[13])
  )
}

const stripCnpjFormatting = val => val.replace(/[\s.\-/]/g, '').toUpperCase()

export const validatorPositive = value => {
  if (value >= 0) {
    return true
  }
  return false
}

export const validatorPassword = password => {
  /* eslint-disable no-useless-escape */
  const regExp = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%&*()]).{6,}/
  /* eslint-enable no-useless-escape */
  const validPassword = regExp.test(password)
  return validPassword
}

export const validatorCreditCard = creditnum => {
  /* eslint-disable no-useless-escape */
  const cRegExp = /^(?:3[47][0-9]{13})$/
  /* eslint-enable no-useless-escape */
  const validCreditCard = cRegExp.test(creditnum)
  return validCreditCard
}

export const validatorUrlValidator = val => {
  if (val === undefined || val === null || val.length === 0) {
    return true
  }
  /* eslint-disable no-useless-escape */
  const re = /^https?:\/\/(?:w{1,3}\.)?[^\s.]+(?:\.[a-z]+)*(?::\d+)?((?:\/\w+)|(?:-\w+))*\/?(?![^<]*(?:<\/\w+>|\/?>))/
  /* eslint-enable no-useless-escape */
  return re.test(val)
}
export const dateFormatValidator = (val, args) => {
  if (val === undefined || val === null || val.length === 0) {
    return true
  }
  return moment(val, args[0], true).isValid()
}
export const timeFormatValidator = val => {
  if (val === undefined || val === null || val.length === 0) {
    return true
  }
  return moment(val, 'HH:mm', true).isValid()
}
export const cpfValidator = val => {
  if (val === undefined || val === null || val.length === 0) {
    return false
  }
  return isValidCpf(val, true)
}
export const cnpjValidator = val => {
  if (val === undefined || val === null || val.length === 0) return false
  const doc = stripCnpjFormatting(val)
  if (/^\d{14}$/.test(doc)) return isValidCpnj(doc, true)
  return isValidCnpjAlfanumerico(doc)
}
export const cnpjCpfValidator = val => {
  if (val === undefined || val === null || val.length === 0) return false
  const doc = stripCnpjFormatting(val)
  if (doc.length === 11 && /^\d{11}$/.test(doc)) return isValidCpf(doc, true)
  if (doc.length === 14) {
    if (/^\d{14}$/.test(doc)) return isValidCpnj(doc, true)
    return isValidCnpjAlfanumerico(doc)
  }
  return false
}
